import TicketComponentSkeleton from '../../components/TicketComponent/TicketComponentSkeleton.jsx';
import { Box, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import TicketComponent from '../../components/TicketComponent/TicketComponent.jsx';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ReadylyHeader from '../../components/ReadylyHeader/ReadylyHeader.jsx';
import { getTicketDetails, getAgentDetails, getOrgData } from '../../api.js'
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import Research from '../../components/ResearchComponent/Research.jsx';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import Summary from '../../components/SummaryComponent/Summary.jsx';
import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import GPTSandbox from './GPTSandbox.jsx';

const AgentAssist = ({ aaTabIndex = 0}) => {
    const [showAgentAssist, setShowAgentAssist] = useState(false);
    const agentDetails = useSelector((state) => state.auth.agentDetails);
    const orgDetails = useSelector((state) => state.auth.orgDetails);
    const ticketDataloading = useSelector((state) => state.ticket.ticketDetailsLoading);
    const ticketDetails = useSelector((state) => state.ticket.ticketDetails);
    const orgDetailsLoading = useSelector((state) => state.auth.orgDetailsLoading);
    const agentDetailsLoading = useSelector((state) => state.auth.agentDetailsLoading);
    const ticketId = useSelector((state) => state.ticket.ticketId);
    const subDomain = useSelector((state) => state.auth.domain);
    const email = useSelector((state) => state.auth.email);
    const ticketingSystem = orgDetails?.ticketing?.platform;
    const prismToken = useSelector((state) => state.auth.prismToken);
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [aaTab, setAaTab] = useState(aaTabIndex);

    useEffect(() => {
        const paramSubdomain = queryParams.get('subDomain');
        if (!subDomain && paramSubdomain) {
            dispatch(getOrgData(paramSubdomain));
        }
    }, [])

    useEffect(() => {
        const paramUserEmail = email || queryParams.get('email');
        const paramTicketId = ticketId || queryParams.get('ticketId');
        const paramticketingSystem = ticketingSystem || queryParams.get("ticketingSystem");
        if ((!email || (Object.keys(agentDetails).length === 0)) && paramUserEmail && prismToken && orgDetails?._id) {
            dispatch(getAgentDetails(paramUserEmail, paramticketingSystem, orgDetails?._id, prismToken));
        }
        if (!ticketId && paramTicketId && prismToken && orgDetails?._id) {
            dispatch(getTicketDetails(paramTicketId, subDomain, paramticketingSystem, orgDetails?._id, prismToken));
        }

    }, [orgDetails, dispatch, queryParams, subDomain])

    const isValid = Object.keys(orgDetails).length > 0 && agentDetails?.verified;
    const loading = ticketDataloading || orgDetailsLoading || agentDetailsLoading;
    const isTicketIdValid = ticketId;

    useEffect(() => {
        if (isTicketIdValid) {
            const timeout = setTimeout(() => setShowAgentAssist(true), 500);
            return () => clearTimeout(timeout);
        } else {
            setShowAgentAssist(false);
        }
    }, [isTicketIdValid]);

    const handleAaTabChange = (event, newValue) => {
        setAaTab(newValue);
    };


    return (
        <>
            <ReadylyHeader />
            <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: ticketDetails?.id ? "space-between" : "center", padding: "20px", width: "100%", gap: "20px", transition: "justify-content 2.0s ease-in-out" }} >
                <div style={{ width: isMobile ? "100%" : ticketDetails?.id ? "40%" : "60%", transition: "width 2.0s ease-in-out" }} >
                    {loading ? (
                        <TicketComponentSkeleton />
                    ) :
                        isValid ?
                            (
                                <TicketComponent subDomain={subDomain} ticketingSystem={ticketingSystem} prismToken={prismToken} ticketId={ticketId} orgId={orgDetails?._id} />
                            )
                            :
                            <Typography variant="h4" color="text.secondary">{Object.keys(orgDetails).length > 0 ? `We verified your email from ${ticketingSystem} CRM and the provided email is invalid` : 'Invalid Sub Domain'}</Typography>
                    }
                </div>

                {showAgentAssist && ticketDetails?.id && (
                    <Box sx={{ width: isMobile ? "100%" : "60%", opacity: ticketDetails?.id ? 1 : 0, transform: ticketDetails?.id ? "translateX(0)" : "translateX(20px)", transition: "opacity 2.0s ease,transform 2.0s ease", border: "1px solid #ddd", borderRadius: 2, boxShadow: 2, overflow: "hidden", bgcolor: "background.paper" }}>
                        <Tabs value={aaTab} variant="fullWidth" onChange={handleAaTabChange} centered sx={{ borderBottom: "1px solid #ddd", bgcolor: "background.paper" }}>
                            <Tab wrapped={isMobile} label="GPT" icon={<AutoAwesomeOutlinedIcon />} sx={{ fontWeight: "bold" }} />
                            <Tab wrapped={isMobile} label="Research" icon={<ScienceOutlinedIcon />} sx={{ fontWeight: "bold" }} />
                            <Tab wrapped={isMobile} label="Summary" icon={<SummarizeOutlinedIcon />} sx={{ fontWeight: "bold" }} />
                        </Tabs>

                        <Box sx={{ padding: 2 }}>
                            {aaTab === 0 && (<GPTSandbox isTicketIdValid={isTicketIdValid} agentDetails={agentDetails} userEmail={email} />)}
                            {aaTab === 1 && (<Research subDomain={subDomain} ticketingSystem={ticketingSystem} prismToken={prismToken} ticketId={ticketId} orgId={orgDetails?._id} agentDetails={agentDetails} userEmail={email} />)}
                            {aaTab === 2 && (<Summary subDomain={subDomain} ticketingSystem={ticketingSystem} prismToken={prismToken} ticketId={ticketId} orgId={orgDetails?._id} agentDetails={agentDetails} userEmail={email} />)}
                        </Box>
                    </Box>

                )}
            </div>
        </>
    )
}

export default AgentAssist